"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RootHelpers = void 0;
var RootHelpers = (function () {
    function RootHelpers() {
    }
    RootHelpers.getMe = function (flApi) {
        if (flApi === void 0) { flApi = null; }
        if (flApi !== null) {
            RootHelpers.me.flApi = flApi;
        }
        return RootHelpers.me;
    };
    RootHelpers.getTranscod = function (typeObj) {
        switch (typeObj) {
            case "entity":
                return [
                    { cn: "id", default: undefined, name: "id", upd: false, check: this.checkNumber, type: 3, subField: [] },
                    { cn: "_ts", default: undefined, name: "_ts", upd: false, type: "x", subField: [] },
                    { cn: "_tsi", default: undefined, name: "_tsi", upd: false, type: "x", subField: [] },
                    { cn: "c1", default: -1, name: "eCN", upd: true, check: this.checkNumber, type: 3, subField: [] },
                    { cn: "c2", default: "E", name: "typeDico", upd: true, type: "x", check: this.checkTypeDico, subField: [] },
                    { cn: "c3", default: undefined, name: "singular", upd: true, type: "x", subField: [] },
                    { cn: "c4", default: "", name: "plural", subField: [], type: "x", upd: true },
                    { cn: "c5", default: "", name: "description", upd: true, type: "x", subField: [] },
                    { cn: "c10", default: -1, name: "entityLinked", subField: [], check: this.checkNumber, type: 3, upd: true },
                    { cn: "c11", default: -1, name: "lastCN", subField: [], check: this.checkNumber, type: 3, upd: false },
                    { cn: "c12", default: 0, name: "specialProc", subField: [], check: this.checkNumber, type: 3, upd: true },
                    { cn: "c13", default: [], name: "filter", subField: [], type: [], upd: true },
                    { cn: "c19", default: undefined, name: "dicoVer", subField: [], check: this.checkNumber, type: 3, upd: false },
                    { cn: "c20", default: 0, name: "nbDoc", subField: [], check: this.checkNumber, type: 3, upd: false },
                    { cn: "c30", doNotScan: true, default: {}, name: "UI", upd: true, type: { a: 1 }, subField: [] },
                ];
            case "string":
                return [
                    { cn: "id", default: undefined, name: "id", upd: false, check: this.checkNumber, type: 3, subField: [] },
                    { cn: "_ts", default: undefined, name: "_ts", upd: false, type: "x", subField: [] },
                    { cn: "_tsi", default: undefined, name: "_tsi", upd: false, type: "x", subField: [] },
                    { cn: "c1", default: undefined, name: "eCN", upd: true, check: this.checkNumber, type: 3, subField: [] },
                    { cn: "c2", default: "F", name: "typeDico", upd: true, type: "x", check: this.checkTypeDico, subField: [] },
                    { cn: "c3", default: undefined, name: "singular", upd: true, type: "x", subField: [] },
                    { cn: "c5", default: "", name: "description", upd: true, type: "x", subField: [] },
                    { cn: "c6", default: undefined, name: "uiType", upd: true, type: "x", subField: [] },
                    { cn: "c7", default: "string", name: "systemType", upd: true, type: "x", subField: [] },
                    { cn: "c8", default: -1, name: "jSonCN", upd: false, check: this.checkNumber, type: 3, subField: [] },
                    { cn: "c9", default: false, name: "repeat", upd: true, type: true, check: this.checkBoolean, subField: [] },
                    { cn: "c14", default: -1, name: "listField", upd: true, check: this.checkNumber, type: 3, subField: [] },
                    { cn: "c18", default: {}, name: "uiConfig", upd: true, type: { a: 1 }, subField: [] },
                    { cn: "c30", doNotScan: true, default: {}, name: "UI", upd: true, type: { a: 1 }, subField: [] },
                    { cn: "c34", doNotScan: true, default: [], name: "defaultValues", upd: true, type: [], subField: [] },
                ];
            case "number":
                return [
                    { cn: "id", default: undefined, name: "id", upd: false, check: this.checkNumber, type: 3, subField: [] },
                    { cn: "_ts", default: undefined, name: "_ts", upd: false, type: "x", subField: [] },
                    { cn: "_tsi", default: undefined, name: "_tsi", upd: false, type: "x", subField: [] },
                    { cn: "c1", default: undefined, name: "eCN", upd: true, check: this.checkNumber, type: 3, subField: [] },
                    { cn: "c2", default: "F", name: "typeDico", upd: true, type: "x", check: this.checkTypeDico, subField: [] },
                    { cn: "c3", default: undefined, name: "singular", upd: true, type: "x", subField: [] },
                    { cn: "c5", default: "", name: "description", upd: true, type: "x", subField: [] },
                    { cn: "c6", default: undefined, name: "uiType", upd: true, type: "x", subField: [] },
                    { cn: "c7", default: "number", name: "systemType", upd: true, type: "x", subField: [] },
                    { cn: "c8", default: -1, name: "jSonCN", upd: false, check: this.checkNumber, type: 3, subField: [] },
                    { cn: "c9", default: false, name: "repeat", upd: true, type: true, check: this.checkBoolean, subField: [] },
                    { cn: "c14", default: -1, name: "listField", upd: true, check: this.checkNumber, type: 3, subField: [] },
                    { cn: "c18", default: {}, name: "uiConfig", upd: true, type: { a: 1 }, subField: [] },
                    { cn: "c30", doNotScan: true, default: {}, name: "UI", upd: true, type: { a: 1 }, subField: [] },
                    { cn: "c34", doNotScan: true, default: [], name: "defaultValues", upd: true, type: [], subField: [] },
                ];
            case "calc":
                return [
                    { cn: "id", default: undefined, name: "id", upd: false, check: this.checkNumber, type: 3, subField: [] },
                    { cn: "_ts", default: undefined, name: "_ts", upd: false, type: "x", subField: [] },
                    { cn: "_tsi", default: undefined, name: "_tsi", upd: false, type: "x", subField: [] },
                    { cn: "c1", default: undefined, name: "eCN", upd: true, check: this.checkNumber, type: 3, subField: [] },
                    { cn: "c2", default: "F", name: "typeDico", upd: true, type: "x", check: this.checkTypeDico, subField: [] },
                    { cn: "c3", default: undefined, name: "singular", upd: true, type: "x", subField: [] },
                    { cn: "c5", default: "", name: "description", upd: true, type: "x", subField: [] },
                    { cn: "c6", default: undefined, name: "uiType", upd: true, type: "x", subField: [] },
                    { cn: "c7", default: "string", name: "systemType", upd: true, type: "x", subField: [] },
                    { cn: "c8", default: -1, name: "jSonCN", upd: false, check: this.checkNumber, type: 3, subField: [] },
                    { cn: "c9", default: false, name: "repeat", upd: true, type: true, check: this.checkBoolean, subField: [] },
                    { cn: "c14", default: -1, name: "listField", upd: true, check: this.checkNumber, type: 3, subField: [] },
                    { cn: "c18", default: {}, name: "uiConfig", upd: true, type: { a: 1 }, subField: [] },
                    { cn: "c30", doNotScan: true, default: {}, name: "UI", upd: true, type: { a: 1 }, subField: [] },
                    { cn: "c33", doNotScan: true, default: [], name: "usedFCNs", upd: true, type: [], subField: [] },
                    { cn: "c36", doNotScan: true, default: [], name: "formula", upd: true, type: "x", subField: [] },
                ];
            case "linkedField":
                return [
                    { cn: "id", default: undefined, name: "id", upd: false, check: this.checkNumber, type: 3, subField: [] },
                    { cn: "_ts", default: undefined, name: "_ts", upd: false, type: "x", subField: [] },
                    { cn: "_tsi", default: undefined, name: "_tsi", upd: false, type: "x", subField: [] },
                    { cn: "c1", default: undefined, name: "eCN", upd: true, check: this.checkNumber, type: 3, subField: [] },
                    { cn: "c2", default: "F", name: "typeDico", upd: true, type: "x", check: this.checkTypeDico, subField: [] },
                    { cn: "c3", default: undefined, name: "singular", upd: true, type: "x", subField: [] },
                    { cn: "c5", default: "", name: "description", upd: true, type: "x", subField: [] },
                    { cn: "c6", default: undefined, name: "uiType", upd: true, type: "x", subField: [] },
                    { cn: "c7", default: "linkedField", name: "systemType", upd: true, type: "x", subField: [] },
                    { cn: "c8", default: -1, name: "jSonCN", upd: false, check: this.checkNumber, type: 3, subField: [] },
                    { cn: "c9", default: false, name: "repeat", upd: true, type: true, check: this.checkBoolean, subField: [] },
                    { cn: "c15", default: undefined, name: "linkedRelation", upd: true, type: [], subField: [] },
                    { cn: "c16", default: undefined, name: "linkedTemplate", upd: true, type: "x", subField: [] },
                    { cn: "c17", default: undefined, name: "extraCNs", upd: true, type: [], subField: [] },
                    { cn: "c18", default: {}, name: "uiConfig", upd: true, type: { a: 1 }, subField: [] },
                    { cn: "c30", doNotScan: true, default: {}, name: "UI", upd: true, type: { a: 1 }, subField: [] },
                    { cn: "c33", doNotScan: true, default: [], name: "usedFCNs", upd: true, type: [], subField: [] },
                ];
            case "pointer":
                return [
                    { cn: "id", default: undefined, name: "id", upd: false, check: this.checkNumber, type: 3, subField: [] },
                    { cn: "_ts", default: undefined, name: "_ts", upd: false, type: "x", subField: [] },
                    { cn: "_tsi", default: undefined, name: "_tsi", upd: false, type: "x", subField: [] },
                    { cn: "c1", default: undefined, name: "eCN", upd: true, check: this.checkNumber, type: 3, subField: [] },
                    { cn: "c2", default: "F", name: "typeDico", upd: true, type: "x", check: this.checkTypeDico, subField: [] },
                    { cn: "c3", default: undefined, name: "singular", upd: true, type: "x", subField: [] },
                    { cn: "c5", default: "", name: "description", upd: true, type: "x", subField: [] },
                    { cn: "c6", default: undefined, name: "uiType", upd: true, type: "x", subField: [] },
                    { cn: "c7", default: "pointer", name: "systemType", upd: true, type: "x", subField: [] },
                    { cn: "c8", default: -1, name: "jSonCN", upd: false, check: this.checkNumber, type: 3, subField: [] },
                    { cn: "c9", default: true, name: "repeat", upd: true, type: true, check: this.checkBoolean, subField: [] },
                    {
                        cn: "c21", default: [{ c22: 0, c23: "" }, { c22: 0, c23: "" }], name: "pointer", subField: [{ cn: "c22", default: undefined, name: "ptEcn", upd: true, type: 2, check: this.checkECN, subField: [] },
                            { cn: "c23", default: undefined, name: "ptTemplate", upd: true, type: "x", subField: [] },
                            { cn: "c24", default: undefined, name: "ptVerb", upd: true, type: "x", subField: [] },
                            {
                                cn: "c25", default: undefined, name: "ptCardinality", upd: true, type: "x",
                                check: this.checkCardinality, subField: []
                            },
                        ],
                        type: [], upd: true,
                    },
                    { cn: "c18", default: {}, name: "uiConfig", upd: true, type: { a: 1 }, subField: [] },
                    { cn: "c30", doNotScan: true, default: {}, name: "UI", upd: true, type: { a: 1 }, subField: [] },
                ];
            case "json":
                return [
                    { cn: "id", default: undefined, name: "id", upd: false, check: this.checkNumber, type: 3, subField: [] },
                    { cn: "_ts", default: undefined, name: "_ts", upd: false, type: "x", subField: [] },
                    { cn: "_tsi", default: undefined, name: "_tsi", upd: false, type: "x", subField: [] },
                    { cn: "c1", default: undefined, name: "eCN", upd: true, check: this.checkNumber, type: 3, subField: [] },
                    { cn: "c2", default: "F", name: "typeDico", upd: true, type: "x", check: this.checkTypeDico, subField: [] },
                    { cn: "c3", default: undefined, name: "singular", upd: true, type: "x", subField: [] },
                    { cn: "c5", default: "", name: "description", upd: true, type: "x", subField: [] },
                    { cn: "c6", default: undefined, name: "uiType", upd: true, type: "x", subField: [] },
                    { cn: "c7", default: "json", name: "systemType", upd: true, type: "x", subField: [] },
                    { cn: "c8", default: -1, name: "jSonCN", upd: false, check: this.checkNumber, type: 3, subField: [] },
                    { cn: "c9", default: false, name: "repeat", upd: true, type: true, check: this.checkBoolean, subField: [] },
                    { cn: "c18", default: {}, name: "uiConfig", upd: true, type: { a: 1 }, subField: [] },
                    { cn: "c30", doNotScan: true, default: {}, name: "UI", upd: true, type: { a: 1 }, subField: [] },
                ];
            case "freejson":
                return [
                    { cn: "id", default: undefined, name: "id", upd: false, check: this.checkNumber, type: 3, subField: [] },
                    { cn: "_ts", default: undefined, name: "_ts", upd: false, type: "x", subField: [] },
                    { cn: "_tsi", default: undefined, name: "_tsi", upd: false, type: "x", subField: [] },
                    { cn: "c1", default: undefined, name: "eCN", upd: true, check: this.checkNumber, type: 3, subField: [] },
                    { cn: "c2", default: "F", name: "typeDico", upd: true, type: "x", check: this.checkTypeDico, subField: [] },
                    { cn: "c3", default: undefined, name: "singular", upd: true, type: "x", subField: [] },
                    { cn: "c5", default: "", name: "description", upd: true, type: "x", subField: [] },
                    { cn: "c6", default: undefined, name: "uiType", upd: true, type: "x", subField: [] },
                    { cn: "c7", default: "freejson", name: "systemType", upd: true, type: "x", subField: [] },
                    { cn: "c8", default: -1, name: "jSonCN", upd: false, check: this.checkNumber, type: 3, subField: [] },
                    { cn: "c9", default: false, name: "repeat", upd: true, type: true, check: this.checkBoolean, subField: [] },
                    { cn: "c18", default: {}, name: "uiConfig", upd: true, type: { a: 1 }, subField: [] },
                    { cn: "c30", doNotScan: true, default: {}, name: "UI", upd: true, type: { a: 1 }, subField: [] },
                ];
            case "rollup":
                return [
                    { cn: "id", default: undefined, name: "id", upd: false, check: this.checkNumber, type: 3, subField: [] },
                    { cn: "_ts", default: undefined, name: "_ts", upd: false, type: "x", subField: [] },
                    { cn: "_tsi", default: undefined, name: "_tsi", upd: false, type: "x", subField: [] },
                    { cn: "c1", default: undefined, name: "eCN", upd: true, check: this.checkNumber, type: 3, subField: [] },
                    { cn: "c2", default: "F", name: "typeDico", upd: true, type: "x", check: this.checkTypeDico, subField: [] },
                    { cn: "c3", default: undefined, name: "singular", upd: true, type: "x", subField: [] },
                    { cn: "c5", default: "", name: "description", upd: true, type: "x", subField: [] },
                    { cn: "c6", default: undefined, name: "uiType", upd: true, type: "x", subField: [] },
                    { cn: "c7", default: "rollup", name: "systemType", upd: true, type: "x", subField: [] },
                    { cn: "c8", default: -1, name: "jSonCN", upd: false, check: this.checkNumber, type: 3, subField: [] },
                    { cn: "c9", default: false, name: "repeat", upd: true, type: true, check: this.checkBoolean, subField: [] },
                    { cn: "c18", default: {}, name: "uiConfig", upd: true, type: { a: 1 }, subField: [] },
                    { cn: "c26", default: undefined, name: "rolPtDetails", upd: true, type: [], check: this.checkRelations, subField: [] },
                    { cn: "c27", default: undefined, name: "rolFunc", upd: true, type: "x", check: this.checkAggpublic, subField: [] },
                    { cn: "c28", default: undefined, name: "rolFCN", upd: true, check: this.checktargetCN, type: 3, subField: [] },
                    { cn: "c29", default: [], name: "rolGroups", upd: true, type: [], check: this.checkGroups, subField: [] },
                    { cn: "c30", doNotScan: true, default: {}, name: "UI", upd: true, type: { a: 1 }, subField: [] },
                    { cn: "c33", doNotScan: true, default: [], name: "usedFCNs", upd: true, type: [], subField: [] },
                ];
            case "uid":
                return [
                    { cn: "id", default: undefined, name: "id", upd: false, check: this.checkNumber, type: 3, subField: [] },
                    { cn: "_ts", default: undefined, name: "_ts", upd: false, type: "x", subField: [] },
                    { cn: "_tsi", default: undefined, name: "_tsi", upd: false, type: "x", subField: [] },
                    { cn: "c1", default: undefined, name: "eCN", upd: true, check: this.checkNumber, type: 3, subField: [] },
                    { cn: "c2", default: "F", name: "typeDico", upd: true, type: "x", check: this.checkTypeDico, subField: [] },
                    { cn: "c3", default: undefined, name: "singular", upd: true, type: "x", subField: [] },
                    { cn: "c5", default: "", name: "description", upd: true, type: "x", subField: [] },
                    { cn: "c6", default: undefined, name: "uiType", upd: true, type: "x", subField: [] },
                    { cn: "c7", default: "uid", name: "systemType", upd: true, type: "x", subField: [] },
                    { cn: "c8", default: -1, name: "jSonCN", upd: false, check: this.checkNumber, type: 3, subField: [] },
                    { cn: "c9", default: false, name: "repeat", upd: true, type: true, check: this.checkBoolean, subField: [] },
                    { cn: "c18", default: {}, name: "uiConfig", upd: true, type: { a: 1 }, subField: [] },
                    { cn: "c30", doNotScan: true, default: {}, name: "UI", upd: true, type: { a: 1 }, subField: [] },
                ];
            case "user":
                return [
                    { cn: "id", default: undefined, name: "id", upd: false, check: this.checkNumber, type: 3, subField: [] },
                    { cn: "_ts", default: undefined, name: "_ts", upd: false, type: "x", subField: [] },
                    { cn: "_tsi", default: undefined, name: "_tsi", upd: false, type: "x", subField: [] },
                    { cn: "c51", default: "", name: "name", type: "x", upd: true, subField: [] },
                    { cn: "c52", default: "", name: "password", type: "x", upd: false, subField: [] },
                    { cn: "c53", default: "", name: "type", type: "x", upd: false, subField: [] },
                    { cn: "c54", default: -1, name: "defaultApp", type: 3, upd: true, subField: [] },
                    { cn: "c55", doNotScan: true, default: {}, name: "settings", type: { a: 1 }, upd: true, subField: [] },
                    { cn: "c56", default: undefined, name: "oldPassword", type: "x", upd: false, subField: [] },
                    { cn: "c57", default: "", name: "callUrl", type: "x", upd: true, subField: [] },
                    { cn: "c58", default: "", name: "logo", upd: true, type: "x", subField: [] },
                ];
            case "application":
                return [
                    { cn: "id", default: undefined, name: "id", upd: false, check: this.checkNumber, type: 3, subField: [] },
                    { cn: "_ts", default: undefined, name: "_ts", upd: false, type: "x", subField: [] },
                    { cn: "_tsi", default: undefined, name: "_tsi", upd: false, type: "x", subField: [] },
                    { cn: "c61", default: undefined, name: "name", upd: false, type: "x", subField: [] },
                    { cn: "c62", default: "", name: "description", upd: true, type: "x", subField: [] },
                    { cn: "c63", default: "default", name: "instanceName", upd: false, type: "x", subField: [] },
                    { cn: "c64", default: "default", name: "dbServer", upd: false, type: { a: 1 }, subField: [] },
                    {
                        cn: "c65", default: [], name: "access", upd: false, type: [], subField: [{ cn: "c66", default: -1, name: "userId", upd: false, check: this.checkNumber, type: 3, subField: [] },
                            { cn: "c67", default: 0, name: "accessLevel", upd: true, check: this.checkNumber, type: 3, subField: [] },
                            { cn: "c80", default: false, name: "newUser", upd: false, type: true, check: this.checkBoolean, doNotScan: true, subField: [] },
                            { cn: "c86", default: {}, name: "jSon", upd: true, type: { a: 1 }, doNotScan: true, subField: [] },
                            { cn: "d66", default: undefined, name: "userName", upd: false, type: "x", subField: [] },
                            { cn: "d67", default: undefined, name: "userPassword", upd: false, type: "x", subField: [] },
                        ],
                    },
                    { cn: "c68", default: false, name: "anonymousAccess", upd: true, type: true, check: this.checkBoolean, subField: [] },
                    { cn: "c69", default: undefined, name: "ownerUserId", upd: true, check: this.checkNumber, type: 3, subField: [] },
                    { cn: "c70", default: 0, name: "lastMaintenance", upd: false, check: this.checkNumber, type: 3, subField: [] },
                    { cn: "c71", default: 0, name: "nextMaintenance", upd: false, check: this.checkNumber, type: 3, subField: [] },
                    { cn: "c72", default: undefined, name: "dbName", upd: false, type: "x", subField: [] },
                    { cn: "c73", default: 0, name: "typeMaintenance", upd: false, check: this.checkNumber, type: 3, subField: [] },
                    {
                        cn: "c74", default: [], name: "histo", upd: false, type: [], subField: [{ cn: "c75", default: undefined, name: "date", upd: false, check: this.checkNumber, type: 3, subField: [] },
                            { cn: "c76", default: undefined, name: "event", upd: false, type: "x", subField: [] },
                            { cn: "c77", default: undefined, name: "info", upd: false, type: "x", subField: [] },
                        ],
                    },
                    { cn: "c78", default: "", name: "timelinedDump", upd: true, type: "x", subField: [] },
                    { cn: "c79", default: "default", name: "site", upd: false, type: "x", subField: [] },
                    {
                        cn: "c81", default: [], name: "services", upd: false, type: [], subField: [{ cn: "c82", default: undefined, name: "id", upd: false, check: this.checkNumber, type: 3, subField: [] },
                            { cn: "c83", default: undefined, name: "config", upd: false, type: { a: 1 }, subField: [] },
                        ],
                    },
                    { cn: "c84", default: "", name: "logo", upd: true, type: "x", subField: [] },
                    { cn: "c85", default: undefined, name: "senders", upd: true, type: [], subField: [] },
                    { cn: "c87", default: 0, name: "features", upd: true, type: 3, subField: [] },
                ];
        }
        throw new Error("Invalid typeObj: " + typeObj);
    };
    RootHelpers.checkTypeDico = function (value, self) {
        return ("EF".indexOf(value) >= 0);
    };
    RootHelpers.checkBoolean = function (value, self) {
        if (value.toString() === "true" || value.toString() === "1") {
            self.repeat = true;
        }
        else {
            self.repeat = false;
        }
        return true;
    };
    RootHelpers.checkData = function (aKey, jVal, self) {
        var _this = this;
        var dataKorek = (aKey.check === undefined) ?
            true :
            aKey.check(jVal.data, self);
        var dataArr = [];
        switch (typeof aKey.type) {
            case "boolean":
                switch (jVal.data) {
                    case true:
                        jVal.data = 1;
                        break;
                    case false:
                        jVal.data = 0;
                        break;
                    case 0:
                    case 1:
                        break;
                    default:
                        throw new Error("invalid data");
                }
                dataArr = [jVal.data];
                break;
            case "number":
                dataKorek = (typeof (jVal.data) === "number");
                dataArr = [jVal.data];
                break;
            case "string":
                dataKorek = (typeof (jVal.data) === "string") || (jVal.data === undefined);
                dataArr = [jVal.data];
                break;
            case "object":
                dataKorek = jVal.data instanceof Array || aKey.type.a === 1;
                dataArr = jVal.data;
                break;
            default:
                throw new Error("unknown type " + (typeof aKey.type));
        }
        if (!dataKorek) {
            throw new Error("invalid data");
        }
        if (aKey.subField.length === 0) {
            return true;
        }
        var _loop_1 = function (idx) {
            aKey.subField.forEach(function (aSubKey) {
                if (dataKorek) {
                    dataKorek = _this.checkData(aSubKey, { data: jVal.data[idx][aSubKey.name] }, self);
                }
            });
        };
        for (var idx = 0; idx < jVal.data.length; idx++) {
            _loop_1(idx);
        }
        if (!dataKorek) {
            throw new Error("invalid data");
        }
        return true;
    };
    RootHelpers.checkNumber = function (value, self) {
        if (Number(value) === NaN) {
            return false;
        }
        try {
            Number.parseInt(value.ToString(), 10);
            return true;
        }
        catch (err) {
            return false;
        }
    };
    RootHelpers.validateTemplate = function (template) {
        if (template.substring(0, 3) !== "<%=") {
            return false;
        }
        if (template.substring(template.length - 2) !== "%>") {
            return false;
        }
        return true;
    };
    RootHelpers.checkCardinality = function (value, self) {
        return ("01N".indexOf(value) >= 0);
    };
    RootHelpers.checkRelations = function (rolPtDetails, self) {
        var bGood = true;
        if (!(rolPtDetails instanceof Array)) {
            return false;
        }
        if (self.c1 === 0) {
            return true;
        }
        var aggFi = RootHelpers.me.flApi.entities.getByEcn(self.c28);
        if (aggFi === null) {
            console.error("rollup.checkrelation: rolFCN " + self.c28 + " not found");
            return false;
        }
        var curEcn = aggFi.eCN;
        rolPtDetails.forEach(function (ptDetail) {
            if (bGood) {
                var ptFild = RootHelpers.me.flApi.entities.getByEcn(ptDetail.ptId);
                if (ptFild === null) {
                    bGood = false;
                    return;
                }
                if (curEcn !== ptFild.pointer[0].ptEcn) {
                    bGood = false;
                    return;
                }
                curEcn = ptFild.pointer[1].ptEcn;
            }
        });
        if (curEcn !== self.c1) {
            return false;
        }
        return bGood;
    };
    RootHelpers.checktargetCN = function (value, self) {
        if (self.c27 === "count" && self.c28 === -1) {
            return true;
        }
        var numFi = RootHelpers.me.flApi.entities.getByFcn(value);
        if (numFi === null) {
            console.log("rollup " + self.id + " rolFCN is not found !");
            return true;
        }
        if (numFi.systemType !== "number") {
            console.error("rollup " + self.id + " rolFCN " + numFi.id + " is not a number !");
        }
        return true;
    };
    RootHelpers.checkGroups = function (rolGroups, self) {
        var bGood = true;
        if (!(rolGroups instanceof Array) || rolGroups.length === 0) {
            rolGroups = [];
            return true;
        }
        if (self.c1 !== 0) {
            return false;
        }
        rolGroups.forEach(function (groupItem) {
            if (bGood) {
                var strFi = RootHelpers.me.flApi.getObject(groupItem);
                if (strFi === null) {
                    console.log("in rollup " + self.id + " grouping field " + groupItem + " not found");
                    bGood = false;
                    return;
                }
                if (["string", "number"].indexOf(strFi.systemType) === -1) {
                    console.log("in rollup " + self.id + " grouping field has a wrong system type: " + strFi.systemType);
                    bGood = false;
                    return;
                }
            }
        });
        return bGood;
    };
    RootHelpers.checkAggpublic = function (values, self) {
        return (["avg", "count", "min", "max", "sum"].indexOf(self.c27)) !== -1;
    };
    RootHelpers.checkECN = function (value, self) {
        var myEnt = self.myApi.entities.getByEcn(value);
        return (myEnt !== null);
    };
    RootHelpers.jsonConcat = function (o1, o2) {
        Object.keys(o2).forEach(function (key) {
            o1[key] = o2[key];
        });
        return o1;
    };
    RootHelpers.isFieldObject = function (typeObject) {
        switch (typeObject) {
            case "application":
            case "user":
            case "entity":
                return false;
            case "freejson":
            case "json":
            case "linkedField":
            case "number":
            case "pointer":
            case "rollup":
            case "string":
            case "uid":
                return true;
            default:
                throw new Error("object not referenced in isFieldObject");
        }
    };
    RootHelpers.me = new RootHelpers();
    return RootHelpers;
}());
exports.RootHelpers = RootHelpers;
